import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 1,
      }}
    >
      <Typography
        component="span"
        sx={{
          fontSize: { xs: "1.1rem", md: "1.25rem" },
          color: "text.secondary",
        }}
      >
        I build
      </Typography>
      <Typography
        component="span"
        sx={{
          fontSize: { xs: "1.1rem", md: "1.25rem" },
          color: "primary.main",
          fontWeight: 600,
          "& .Typewriter": {
            display: "inline",
          },
        }}
      >
        <Typewriter
          options={{
            strings: [
              "Enterprise SaaS platforms",
              "Oracle Fusion API integrations",
              "Invoicing and accounting systems",
              "React/Next.js dashboards",
              "Web3 DApps and wallet flows",
              "MERN stack product backends",
            ],
            autoStart: true,
            loop: true,
            deleteSpeed: 50,
            delay: 80,
          }}
        />
      </Typography>
    </Box>
  );
}

export default Type;
